import type { CustomerStateType } from 'src/routes/Checkout/store/domains/customer/types';

export const initialValues: CustomerStateType = {
  name: null,
  surname: null,
  patronymic: null,
  passportNumber: null,
  nationalityId: null,
  address: null,
  gender: null,
  birthday: null,
  email: null,
  phone: null,
  docType: null,
};

export const RUSSIA_NATIONALITY_ID = 225;
